import api from './api';

export interface NoImputable {
    nroRubro: number;
    descripcioncta: string;
    nombreCuenta?: string;
    segmento: number;
    totalizaEn?: number;
    saldo?: number;
}

export interface NoImputableSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface NoImputablePagedResult {
    items: NoImputable[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const noImputableService = {
    getNoImputables: async (params: NoImputableSearchParams): Promise<NoImputablePagedResult> => {
        const response = await api.get<NoImputablePagedResult>('/api/NoImputables', { params });
        return response.data;
    },

    getNoImputable: async (nroRubro: number): Promise<NoImputable> => {
        const response = await api.get<NoImputable>(`/api/NoImputables/${nroRubro}`);
        return response.data;
    },

    createNoImputable: async (noImputable: NoImputable): Promise<NoImputable> => {
        const response = await api.post<NoImputable>('/api/NoImputables', noImputable);
        return response.data;
    },

    updateNoImputable: async (nroRubro: number, noImputable: Partial<NoImputable>): Promise<void> => {
        await api.put(`/api/NoImputables/${nroRubro}`, noImputable);
    },

    deleteNoImputable: async (nroRubro: number): Promise<void> => {
        await api.delete(`/api/NoImputables/${nroRubro}`);
    }
};

export default noImputableService;
